import { render } from "./bill-sum-list.vue?vue&type=template&id=ad166b16&ts=true"
import script from "./bill-sum-list.vue?vue&type=script&lang=ts"
export * from "./bill-sum-list.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__